import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { style: {"width":"100%","height":"calc(100vh - 80px - 64px)","position":"relative"} }
const _hoisted_2 = { style: {"width":"192px"} }
const _hoisted_3 = {
  key: 0,
  style: {"position":"absolute","top":"0","left":"0","overflow-y":"auto","height":"100%","max-height":"calc(100vh - 64px - 52px)","padding":"16px","width":"200px","background":"whitesmoke","z-index":"1","border-right":"1px solid rgba(0, 0, 0, 0.2)"},
  class: "px-0 py-2 scrollbar-hidden"
}
const _hoisted_4 = { class: "text-caption" }
const _hoisted_5 = { class: "text-subtitle-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomToolbarBtn = _resolveComponent("CustomToolbarBtn")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_CustomToolbarDropdown = _resolveComponent("CustomToolbarDropdown")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_BoxPopupMenu = _resolveComponent("BoxPopupMenu")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_DesignerLayout = _resolveComponent("DesignerLayout")!
  const _component_ReportPage = _resolveComponent("ReportPage")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_PropertiesEditor = _resolveComponent("PropertiesEditor")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_DesignerTheme = _resolveComponent("DesignerTheme")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, {
      "no-gutters": "",
      style: {"position":"sticky","top":"0","left":"0","height":"48px"},
      class: "px-2"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: 7,
          class: "d-flex flex-row align-center h-100"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_CustomToolbarBtn, {
                icon: "$fa-bars",
                title: "Vos objets",
                onClick: _ctx.toggleObjectsMenu
              }, null, 8, ["onClick"])
            ]),
            _createVNode(_component_v_divider, {
              vertical: "",
              inset: ""
            }),
            (_ctx.showDesignerMenu)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_CustomToolbarDropdown, {
                    icon: "$fa-square",
                    title: "Basic"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, { lines: "one" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, { onClick: _ctx.addTextField }, {
                            append: _withCtx(() => [
                              _createVNode(_component_v_icon, { size: "x-small" }, {
                                default: _withCtx(() => _cache[11] || (_cache[11] = [
                                  _createTextVNode("$fa-plus")
                                ])),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => _cache[12] || (_cache[12] = [
                                  _createTextVNode("Texte")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_v_list_item, { onClick: _ctx.addTitle }, {
                            append: _withCtx(() => [
                              _createVNode(_component_v_icon, { size: "x-small" }, {
                                default: _withCtx(() => _cache[13] || (_cache[13] = [
                                  _createTextVNode("$fa-plus")
                                ])),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => _cache[14] || (_cache[14] = [
                                  _createTextVNode("Titre")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_v_list_item, null, {
                            append: _withCtx(() => [
                              _createVNode(_component_v_icon, { size: "x-small" }, {
                                default: _withCtx(() => _cache[15] || (_cache[15] = [
                                  _createTextVNode("$fa-plus")
                                ])),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => _cache[16] || (_cache[16] = [
                                  _createTextVNode("Image")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_list_item, null, {
                            append: _withCtx(() => [
                              _createVNode(_component_v_icon, { size: "x-small" }, {
                                default: _withCtx(() => _cache[17] || (_cache[17] = [
                                  _createTextVNode("$fa-plus")
                                ])),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => _cache[18] || (_cache[18] = [
                                  _createTextVNode("Trait")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_CustomToolbarDropdown, {
                    icon: "$fa-table",
                    title: "Widgets"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, { lines: "one" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, null, {
                            append: _withCtx(() => [
                              _createVNode(_component_v_icon, { size: "x-small" }, {
                                default: _withCtx(() => _cache[19] || (_cache[19] = [
                                  _createTextVNode("$fa-plus")
                                ])),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => _cache[20] || (_cache[20] = [
                                  _createTextVNode("Carte")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_list_item, { onClick: _ctx.addIndicator }, {
                            append: _withCtx(() => [
                              _createVNode(_component_v_icon, { size: "x-small" }, {
                                default: _withCtx(() => _cache[21] || (_cache[21] = [
                                  _createTextVNode("$fa-plus")
                                ])),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => _cache[22] || (_cache[22] = [
                                  _createTextVNode("Indicateur")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_v_list_item, { onClick: _ctx.addRatio }, {
                            append: _withCtx(() => [
                              _createVNode(_component_v_icon, { size: "x-small" }, {
                                default: _withCtx(() => _cache[23] || (_cache[23] = [
                                  _createTextVNode("$fa-plus")
                                ])),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => _cache[24] || (_cache[24] = [
                                  _createTextVNode("Ratio")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_v_list_item, { onClick: _ctx.addAccountingResults }, {
                            append: _withCtx(() => [
                              _createVNode(_component_v_icon, { size: "x-small" }, {
                                default: _withCtx(() => _cache[25] || (_cache[25] = [
                                  _createTextVNode("$fa-plus")
                                ])),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => _cache[26] || (_cache[26] = [
                                  _createTextVNode(" Tableaux comptables ")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_CustomToolbarDropdown, {
                    icon: "$fa-table-cells-large",
                    title: "Conteneurs"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, { lines: "one" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, {
                            onClick: _ctx.addBox,
                            density: "compact"
                          }, {
                            append: _withCtx(() => [
                              _createVNode(_component_v_icon, { size: "x-small" }, {
                                default: _withCtx(() => _cache[27] || (_cache[27] = [
                                  _createTextVNode("$fa-plus")
                                ])),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => _cache[28] || (_cache[28] = [
                                  _createTextVNode("Boite simple")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_v_list_item, {
                            onClick: _ctx.addSimpleContainer,
                            density: "compact"
                          }, {
                            append: _withCtx(() => [
                              _createVNode(_component_v_icon, { size: "x-small" }, {
                                default: _withCtx(() => _cache[29] || (_cache[29] = [
                                  _createTextVNode("$fa-square")
                                ])),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => _cache[30] || (_cache[30] = [
                                  _createTextVNode("Conteneur simple")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_v_list_item, {
                            onClick: _ctx.addGridBox,
                            density: "compact"
                          }, {
                            append: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                size: "x-small",
                                icon: "$fa-border-all"
                              })
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => _cache[31] || (_cache[31] = [
                                  _createTextVNode("Grille")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_v_list_item, { density: "compact" }, {
                            append: _withCtx(() => [
                              _createVNode(_component_v_icon, { size: "x-small" }, {
                                default: _withCtx(() => _cache[32] || (_cache[32] = [
                                  _createTextVNode("$fa-plus")
                                ])),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => _cache[33] || (_cache[33] = [
                                  _createTextVNode("Carte")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_v_spacer),
        _createVNode(_component_v_col, {
          cols: "2",
          class: "py-3 d-flex justify-end h-100"
        }, {
          default: _withCtx(() => [
            (_ctx.selectedBox && _ctx.showDesignerMenu)
              ? (_openBlock(), _createBlock(_component_CustomToolbarBtn, {
                  key: 0,
                  icon: "$fa-gear",
                  title: "Customisation",
                  class: "ml-1 px-1",
                  onClick: _ctx.openCustomizationPane
                }, null, 8, ["onClick"]))
              : (_ctx.selectedBox && _ctx.showReportMenu)
                ? (_openBlock(), _createBlock(_component_CustomToolbarBtn, {
                    key: 1,
                    icon: "$fa-gear",
                    title: "Contenu",
                    class: "ml-1 px-1",
                    onClick: _ctx.openCustomizationPane
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true),
            (_ctx.showDesignerMenu)
              ? (_openBlock(), _createBlock(_component_CustomToolbarBtn, {
                  key: 2,
                  icon: "$fa-gear",
                  title: "Thèmes",
                  class: "ml-1 px-1",
                  onClick: _ctx.openThemeEditor
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "3",
          class: "py-3 d-flex justify-end h-100"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn_toggle, {
              modelValue: _ctx.togglePreview,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.togglePreview) = $event)),
              mandatory: "force",
              class: "h-100"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  density: "compact",
                  size: "small",
                  rounded: "0",
                  variant: "outlined"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      size: "small",
                      class: "mr-2"
                    }, {
                      default: _withCtx(() => _cache[34] || (_cache[34] = [
                        _createTextVNode("$fa-object-ungroup")
                      ])),
                      _: 1
                    }),
                    _cache[35] || (_cache[35] = _createTextVNode(" Edition "))
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  density: "compact",
                  size: "small",
                  rounded: "0",
                  variant: "outlined"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      size: "small",
                      class: "mr-2"
                    }, {
                      default: _withCtx(() => _cache[36] || (_cache[36] = [
                        _createTextVNode("$fa-tachometer-alt")
                      ])),
                      _: 1
                    }),
                    _cache[37] || (_cache[37] = _createTextVNode(" Rapport "))
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  density: "compact",
                  size: "small",
                  rounded: "0",
                  variant: "outlined"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      size: "small",
                      class: "mr-2"
                    }, {
                      default: _withCtx(() => _cache[38] || (_cache[38] = [
                        _createTextVNode("$oss-eye")
                      ])),
                      _: 1
                    }),
                    _cache[39] || (_cache[39] = _createTextVNode(" Preview "))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, {
      "no-gutters": "",
      style: {"position":"relative"}
    }, {
      default: _withCtx(() => [
        (_ctx.isObjectsMenuShown)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_v_card, {
                class: "ma-0",
                elevation: "0",
                rounded: "0",
                style: {"background":"whitesmoke"}
              }, {
                default: _withCtx(() => [
                  (_ctx.layout)
                    ? (_openBlock(), _createBlock(_component_v_row, {
                        key: 0,
                        "no-gutters": ""
                      }, {
                        default: _withCtx(() => [
                          (_ctx.layout.allObjects.length)
                            ? (_openBlock(), _createBlock(_component_v_list, {
                                key: 0,
                                style: {"width":"100%","background":"whitesmoke"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_draggable, {
                                    list: _ctx.layout.allObjects,
                                    onChange: _ctx.onDragChange,
                                    onEnd: _ctx.onDragEnd,
                                    onStart: _ctx.onDragStart,
                                    group: { name: 'a', pull: 'clone', put: false }
                                  }, {
                                    item: _withCtx(({ element: object }) => [
                                      (_openBlock(), _createBlock(_component_v_list_item, {
                                        density: "compact",
                                        class: "pl-2 pr-0",
                                        key: object.box.id,
                                        style: _normalizeStyle({
                                            background:
                                                _ctx.selectedBox === object.box
                                                    ? 'rgba(249, 177, 40, 0.3)'
                                                    : null,
                                            cursor: 'pointer',
                                        }),
                                        onClick: _withModifiers(($event: any) => (_ctx.selectBox(object.box)), ["stop"])
                                      }, {
                                        prepend: _withCtx(() => [
                                          _createVNode(_component_v_icon, { size: "small" }, {
                                            default: _withCtx(() => _cache[40] || (_cache[40] = [
                                              _createTextVNode("$fa-square")
                                            ])),
                                            _: 1
                                          })
                                        ]),
                                        append: _withCtx(() => [
                                          (object.box && !object.box.visible)
                                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                                key: 0,
                                                size: "x-small"
                                              }, {
                                                default: _withCtx(() => _cache[41] || (_cache[41] = [
                                                  _createTextVNode("$oss-eye-slash")
                                                ])),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true),
                                          _createVNode(_component_BoxPopupMenu, {
                                            box: object.box,
                                            hideOptions: _ctx.hiddenObjectsMenuOptions,
                                            onDuplicateBox: _ctx.duplicateBox,
                                            onDeleteBox: _ctx.removeBox,
                                            onEditBox: _ctx.editBox,
                                            onMoveBoxToFront: _ctx.moveBoxToFront,
                                            onMoveBoxToBack: _ctx.moveBoxToBack,
                                            onMoveBoxForward: _ctx.moveBoxForward,
                                            onMoveBoxBackward: _ctx.moveBoxBackward,
                                            onToggleBoxVisibility: _ctx.toggleBoxVisibility
                                          }, null, 8, ["box", "hideOptions", "onDuplicateBox", "onDeleteBox", "onEditBox", "onMoveBoxToFront", "onMoveBoxToBack", "onMoveBoxForward", "onMoveBoxBackward", "onToggleBoxVisibility"])
                                        ]),
                                        default: _withCtx(() => [
                                          _createElementVNode("span", {
                                            class: _normalizeClass(`px-${object.depth}`)
                                          }, null, 2),
                                          _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                            activator: _withCtx(({ props }) => [
                                              _createVNode(_component_v_list_item_title, _normalizeProps(_guardReactiveProps(props)), {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(object.box.name), 1)
                                                ]),
                                                _: 2
                                              }, 1040)
                                            ]),
                                            default: _withCtx(() => [
                                              _createElementVNode("span", _hoisted_4, _toDisplayString(object.box.name), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_v_list_item_subtitle, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(object.box.friendlyTypename), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1032, ["style", "onClick"]))
                                    ]),
                                    _: 1
                                  }, 8, ["list", "onChange", "onEnd", "onStart"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_v_col, {
          cols: !_ctx.visibleEditionOptions ? 12 : 9
        }, {
          default: _withCtx(() => [
            (_ctx.togglePreview !== 1)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onDrop: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args))),
                  onDragover: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
                }, [
                  _createVNode(_component_DesignerLayout, {
                    onLayout: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setLayout($event))),
                    onSelectedBox: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleSelectedBox($event))),
                    onDuplicateBox: _ctx.duplicateBox,
                    onDeleteBox: _ctx.removeBox,
                    onEditBox: _ctx.editBox,
                    onMoveBoxToFront: _ctx.moveBoxToFront,
                    onMoveBoxToBack: _ctx.moveBoxToBack,
                    onMoveBoxForward: _ctx.moveBoxForward,
                    onMoveBoxBackward: _ctx.moveBoxBackward,
                    onToggleBoxVisibility: _ctx.toggleBoxVisibility,
                    initialLayout: _ctx.layout,
                    editedBox: _ctx.editedBox,
                    viewType: _ctx.viewType,
                    view: _ctx.selectedView,
                    generalTheme: _ctx.selectedGeneralTheme,
                    ref: "designerLayout"
                  }, null, 8, ["onDuplicateBox", "onDeleteBox", "onEditBox", "onMoveBoxToFront", "onMoveBoxToBack", "onMoveBoxForward", "onMoveBoxBackward", "onToggleBoxVisibility", "initialLayout", "editedBox", "viewType", "view", "generalTheme"])
                ], 32))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  onDrop: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onDropOnReport && _ctx.onDropOnReport(...args))),
                  onDragover: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"]))
                }, [
                  _createVNode(_component_ReportPage, {
                    themeSettings: _ctx.themeSettings,
                    reportType: _ctx.selectedReportType,
                    initialReport: _ctx.workingReport,
                    onReport: _ctx.onReportEmitted,
                    onSelectedBox: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleSelectedBox($event))),
                    onDuplicateBox: _ctx.duplicateBox,
                    onDeleteBox: _ctx.removeBox,
                    onEditBox: _ctx.editBox,
                    onMoveBoxToFront: _ctx.moveBoxToFront,
                    onMoveBoxToBack: _ctx.moveBoxToBack,
                    onMoveBoxForward: _ctx.moveBoxForward,
                    onMoveBoxBackward: _ctx.moveBoxBackward,
                    onToggleBoxVisibility: _ctx.toggleBoxVisibility
                  }, null, 8, ["themeSettings", "reportType", "initialReport", "onReport", "onDuplicateBox", "onDeleteBox", "onEditBox", "onMoveBoxToFront", "onMoveBoxToBack", "onMoveBoxForward", "onMoveBoxBackward", "onToggleBoxVisibility"])
                ], 32))
          ]),
          _: 1
        }, 8, ["cols"]),
        (_ctx.showDesignerMenu && _ctx.visibleEditionOptions)
          ? (_openBlock(), _createBlock(_component_v_col, {
              key: 1,
              cols: "3",
              style: {"background":"white"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  rounded: "0",
                  flat: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, { class: "d-flex flex-row" }, {
                      default: _withCtx(() => [
                        _cache[42] || (_cache[42] = _createTextVNode(" Options d'édition ")),
                        _createVNode(_component_v_spacer),
                        _createElementVNode("div", null, [
                          _createVNode(_component_v_btn_icon, {
                            size: "small",
                            onClick: _ctx.closeCustomizationPane,
                            icon: "$fa-times"
                          }, null, 8, ["onClick"])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_tabs, {
                  "fixed-tabs": "",
                  modelValue: _ctx.editorTab,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.editorTab) = $event))
                }, {
                  default: _withCtx(() => [
                    (!_ctx.themeEditorOnly)
                      ? (_openBlock(), _createBlock(_component_v_tab, {
                          key: 0,
                          value: 0,
                          href: "#properties-tab"
                        }, {
                          default: _withCtx(() => _cache[43] || (_cache[43] = [
                            _createTextVNode("Propriétés")
                          ])),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_v_tab, {
                          key: 1,
                          value: 1,
                          href: "#themes-tab"
                        }, {
                          default: _withCtx(() => _cache[44] || (_cache[44] = [
                            _createTextVNode("Thème")
                          ])),
                          _: 1
                        }))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_v_tabs_window, {
                  modelValue: _ctx.editorTab,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.editorTab) = $event))
                }, {
                  default: _withCtx(() => [
                    (!_ctx.themeEditorOnly)
                      ? (_openBlock(), _createBlock(_component_v_window_item, {
                          key: 0,
                          value: "properties-tab"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card, { rounded: "0" }, {
                              default: _withCtx(() => [
                                (_ctx.selectedBox)
                                  ? (_openBlock(), _createBlock(_component_v_row, {
                                      key: 0,
                                      "no-gutters": "",
                                      class: "px-2 py-3 scrollbar-hidden d-flex align-start",
                                      style: {"max-height":"calc(100vh - 56px - 176px)","overflow-y":"auto","position":"relative","z-index":"2"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          class: "d-flex flex-row pb-3 align-start"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_row, {
                                              "no-gutters": "",
                                              class: "px-1"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_col, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_text_field_filled, {
                                                      modelValue: _ctx.selectedBox.name,
                                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedBox.name) = $event)),
                                                      label: "Nom du composant",
                                                      "hide-details": ""
                                                    }, null, 8, ["modelValue"])
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_col, {
                                                  cols: "3",
                                                  class: "mb-3 d-flex flex-row align-self-start"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_btn_icon, {
                                                      icon: "$fa-clone",
                                                      onClick: _ctx.duplicateSelectedBox,
                                                      size: "small"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_icon),
                                                        _createVNode(_component_v_tooltip, { activator: "parent" }, {
                                                          default: _withCtx(() => _cache[45] || (_cache[45] = [
                                                            _createTextVNode("Supprimer")
                                                          ])),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    }, 8, ["onClick"]),
                                                    _createVNode(_component_v_btn_icon, {
                                                      icon: "$oss-trash",
                                                      size: "small",
                                                      onClick: _ctx.removeSelectedBox
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_icon, { color: "error" }),
                                                        _createVNode(_component_v_tooltip, { activator: "parent" }, {
                                                          default: _withCtx(() => _cache[46] || (_cache[46] = [
                                                            _createTextVNode("Supprimer")
                                                          ])),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    }, 8, ["onClick"])
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          class: "d-flex flex-row align-self-start"
                                        }, {
                                          default: _withCtx(() => [
                                            (_ctx.selectedBox.properties)
                                              ? (_openBlock(), _createBlock(_component_PropertiesEditor, {
                                                  key: 0,
                                                  properties: _ctx.selectedBox.properties,
                                                  propertiesOptions: _ctx.selectedBox.propertiesOptions
                                                }, null, 8, ["properties", "propertiesOptions"]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_divider)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          class: "d-flex align-start"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_expansion_panels, {
                                              accordion: "",
                                              flat: "",
                                              class: "align-self-start"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_expansion_panel, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_expansion_panel_title, {
                                                      "disable-icon-rotate": "",
                                                      class: "px-2"
                                                    }, {
                                                      actions: _withCtx(() => [
                                                        _createVNode(_component_v_icon, {
                                                          size: "x-small",
                                                          color: "secondary"
                                                        }, {
                                                          default: _withCtx(() => _cache[47] || (_cache[47] = [
                                                            _createTextVNode(" $fa-plus ")
                                                          ])),
                                                          _: 1
                                                        })
                                                      ]),
                                                      default: _withCtx(() => [
                                                        _cache[48] || (_cache[48] = _createElementVNode("span", null, "Plus d'options...", -1))
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_expansion_panel_text, { class: "wrapper-px-2" }, {
                                                      default: _withCtx(() => [
                                                        (_ctx.selectedBox.style)
                                                          ? (_openBlock(), _createBlock(_component_v_col, {
                                                              key: 0,
                                                              cols: "12",
                                                              class: "py-3 px-0 d-flex flex-row"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _cache[51] || (_cache[51] = _createElementVNode("h4", null, "Style", -1)),
                                                                _createVNode(_component_v_spacer),
                                                                _createVNode(_component_v_btn, {
                                                                  size: "small",
                                                                  onClick: _ctx.copyBoxStyleFromSelectedTheme
                                                                }, {
                                                                  prepend: _withCtx(() => [
                                                                    _createVNode(_component_v_icon, { color: "white" }, {
                                                                      default: _withCtx(() => _cache[49] || (_cache[49] = [
                                                                        _createTextVNode("$fa-copy")
                                                                      ])),
                                                                      _: 1
                                                                    })
                                                                  ]),
                                                                  default: _withCtx(() => [
                                                                    _cache[50] || (_cache[50] = _createElementVNode("span", null, "Style du thèmess", -1))
                                                                  ]),
                                                                  _: 1
                                                                }, 8, ["onClick"])
                                                              ]),
                                                              _: 1
                                                            }))
                                                          : _createCommentVNode("", true),
                                                        _createVNode(_component_v_col, {
                                                          cols: "12",
                                                          class: "px-0"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            (_ctx.selectedBox.style)
                                                              ? (_openBlock(), _createBlock(_component_PropertiesEditor, {
                                                                  key: 0,
                                                                  properties: _ctx.selectedBox.style,
                                                                  propertiesOptions: 
                                                            _ctx.selectedBox.styleOptions
                                                        
                                                                }, null, 8, ["properties", "propertiesOptions"]))
                                                              : _createCommentVNode("", true)
                                                          ]),
                                                          _: 1
                                                        }),
                                                        (
                                                        _ctx.selectedBox.style &&
                                                        _ctx.selectedBox.style.boxTitle &&
                                                        _ctx.selectedBox.properties.title
                                                    )
                                                          ? (_openBlock(), _createBlock(_component_v_col, {
                                                              key: 1,
                                                              cols: "12",
                                                              class: "py-2 px-0 d-flex flex-row"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _cache[54] || (_cache[54] = _createElementVNode("h4", null, "Style du titre de la boite", -1)),
                                                                _createVNode(_component_v_spacer),
                                                                _createVNode(_component_v_btn, {
                                                                  size: "small",
                                                                  elevation: "0",
                                                                  onClick: _ctx.copyBoxTitleStyleFromSelectedTheme
                                                                }, {
                                                                  prepend: _withCtx(() => [
                                                                    _createVNode(_component_v_icon, { color: "white" }, {
                                                                      default: _withCtx(() => _cache[52] || (_cache[52] = [
                                                                        _createTextVNode("$fa-copy")
                                                                      ])),
                                                                      _: 1
                                                                    })
                                                                  ]),
                                                                  default: _withCtx(() => [
                                                                    _cache[53] || (_cache[53] = _createElementVNode("span", null, "Style du thèmes", -1))
                                                                  ]),
                                                                  _: 1
                                                                }, 8, ["onClick"])
                                                              ]),
                                                              _: 1
                                                            }))
                                                          : _createCommentVNode("", true),
                                                        _createVNode(_component_v_col, {
                                                          cols: "12",
                                                          class: "px-0"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            (
                                                            _ctx.selectedBox.style &&
                                                            _ctx.selectedBox.style.boxTitle &&
                                                            _ctx.selectedBox.properties.title
                                                        )
                                                              ? (_openBlock(), _createBlock(_component_PropertiesEditor, {
                                                                  key: 0,
                                                                  properties: _ctx.selectedBox.style.boxTitle,
                                                                  propertiesOptions: 
                                                            _ctx.selectedBox.styleOptions.boxTitle
                                                        
                                                                }, null, 8, ["properties", "propertiesOptions"]))
                                                              : _createCommentVNode("", true)
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_window_item, { value: "themes-tab" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DesignerTheme, {
                          tablesThemeSettings: _ctx.tablesThemeSettings,
                          chartsThemeSettings: _ctx.chartsThemeSettings,
                          generalThemeSettings: _ctx.generalThemeSettings
                        }, null, 8, ["tablesThemeSettings", "chartsThemeSettings", "generalThemeSettings"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : (_ctx.showReportMenu && _ctx.visibleEditionOptions)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 2,
                cols: "3",
                style: {"background":"white"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    rounded: "0",
                    flat: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, { class: "d-flex flex-row" }, {
                        default: _withCtx(() => [
                          _cache[55] || (_cache[55] = _createTextVNode(" Options du contenu ")),
                          _createVNode(_component_v_spacer),
                          _createElementVNode("div", null, [
                            _createVNode(_component_v_btn_icon, {
                              icon: "$fa-times",
                              size: "small",
                              onClick: _ctx.closeCustomizationPane
                            }, null, 8, ["onClick"])
                          ])
                        ]),
                        _: 1
                      }),
                      (_ctx.selectedBox)
                        ? (_openBlock(), _createBlock(_component_v_row, {
                            key: 0,
                            "no-gutters": "",
                            class: "px-2 py-3 scrollbar-hidden d-flex align-start",
                            style: {"max-height":"calc(100vh - 56px - 176px)","overflow-y":"auto","position":"relative","z-index":"2"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "12",
                                class: "d-flex flex-row pb-3 align-start"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.selectedBox.name), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                class: "d-flex flex-row align-self-start"
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.selectedBox.reportProperties)
                                    ? (_openBlock(), _createBlock(_component_PropertiesEditor, {
                                        key: 0,
                                        properties: _ctx.selectedBox.reportProperties,
                                        propertiesOptions: _ctx.selectedBox.reportPropertiesOptions
                                      }, null, 8, ["properties", "propertiesOptions"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}